var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Card", {
        attrs: { title: "Subscription" },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function() {
              return [
                _c(
                  "div",
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "pb-3 flex justify-between items-center w-full"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex items-center w-full" },
                          [
                            _c(
                              "el-row",
                              {
                                staticClass: "w-full",
                                attrs: { gutter: "10" }
                              },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: "8" } },
                                  [
                                    _c("date-range-picker", {
                                      ref: "picker",
                                      staticClass: "w-full",
                                      attrs: {
                                        timePicker: false,
                                        showDropdowns: false,
                                        "max-date": _vm.maxDate,
                                        opens: "right",
                                        "auto-apply": true
                                      },
                                      on: { update: _vm.onChangeDate },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "input",
                                          fn: function(picker) {
                                            return [
                                              _vm._v(
                                                "\n                    From: " +
                                                  _vm._s(
                                                    _vm.moment(picker.startDate)
                                                  ) +
                                                  " - To: " +
                                                  _vm._s(
                                                    _vm.moment(picker.endDate)
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          }
                                        }
                                      ]),
                                      model: {
                                        value: _vm.dateRange,
                                        callback: function($$v) {
                                          _vm.dateRange = $$v
                                        },
                                        expression: "dateRange"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: "8" } },
                                  [
                                    _c("el-input", {
                                      staticClass: "w-full",
                                      attrs: { placeholder: "search" },
                                      on: { change: _vm.search },
                                      model: {
                                        value: _vm.filter.q,
                                        callback: function($$v) {
                                          _vm.$set(_vm.filter, "q", $$v)
                                        },
                                        expression: "filter.q"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: "8" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "w-full",
                                        attrs: {
                                          filterable: "",
                                          placeholder: "Select Channel"
                                        },
                                        on: { change: _vm.search },
                                        model: {
                                          value: _vm.filter.channel,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filter, "channel", $$v)
                                          },
                                          expression: "filter.channel"
                                        }
                                      },
                                      _vm._l(_vm.paymentChannels, function(v) {
                                        return _c(
                                          "el-option",
                                          {
                                            key: "channel-" + v.key,
                                            attrs: { value: v.key }
                                          },
                                          [_vm._v(">" + _vm._s(v.value))]
                                        )
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "pb-3 flex justify-between items-center w-full"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex items-center w-full" },
                          [
                            _c(
                              "el-row",
                              {
                                staticClass: "w-full",
                                attrs: { gutter: "10" }
                              },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: "8" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "w-full",
                                        attrs: {
                                          filterable: "",
                                          placeholder: "Select Type"
                                        },
                                        on: { change: _vm.search },
                                        model: {
                                          value: _vm.filter.type,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filter, "type", $$v)
                                          },
                                          expression: "filter.type"
                                        }
                                      },
                                      _vm._l(_vm.paymentTypes, function(v) {
                                        return _c(
                                          "el-option",
                                          {
                                            key: "type-" + v.key,
                                            attrs: { value: v.key }
                                          },
                                          [_vm._v(_vm._s(v.value))]
                                        )
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: "8" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "w-full",
                                        attrs: {
                                          filterable: "",
                                          placeholder: "Select Status"
                                        },
                                        on: { change: _vm.search },
                                        model: {
                                          value: _vm.filter.status,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filter, "status", $$v)
                                          },
                                          expression: "filter.status"
                                        }
                                      },
                                      _vm._l(_vm.paymentStatuses, function(v) {
                                        return _c(
                                          "el-option",
                                          {
                                            key: "status-" + v.key,
                                            attrs: { value: v.key }
                                          },
                                          [_vm._v(_vm._s(v.value))]
                                        )
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: "8" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "w-full",
                                        attrs: {
                                          filterable: "",
                                          placeholder: "First Time?"
                                        },
                                        on: { change: _vm.search },
                                        model: {
                                          value: _vm.filter.first_time,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filter,
                                              "first_time",
                                              $$v
                                            )
                                          },
                                          expression: "filter.first_time"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-option",
                                          { attrs: { value: null } },
                                          [_vm._v("All")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-option",
                                          { attrs: { value: true } },
                                          [_vm._v("Yes")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-option",
                                          { attrs: { value: false } },
                                          [_vm._v("No")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "pb-6 flex",
                        staticStyle: { gap: "16px" }
                      },
                      [
                        _c("card-stats", {
                          attrs: {
                            statSubtitle: "Subscription Revenue",
                            statTitle:
                              "$" +
                              _vm.formatPrice(
                                parseFloat(
                                  _vm.total_subscription_history
                                ).toFixed(2)
                              )
                          }
                        }),
                        _vm._v(" "),
                        _c("card-stats", {
                          attrs: {
                            statSubtitle: "Gross Revenue",
                            statTitle:
                              "$" +
                              _vm.formatPrice(
                                parseFloat(
                                  _vm.gross_subscription_history
                                ).toFixed(2)
                              )
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "data-tables-server",
                      {
                        ref: "tableTransaction",
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.data,
                          total: _vm.total,
                          "pagination-props": {
                            background: true,
                            pageSizes: [_vm.displayingItem]
                          }
                        },
                        on: { "query-change": _vm.onChangeTable }
                      },
                      [
                        _vm._l(_vm.titles, function(title) {
                          return _c("el-table-column", {
                            key: title.prop,
                            attrs: {
                              prop: title.prop,
                              label: title.label,
                              width: "200",
                              sortable: "custom"
                            }
                          })
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "Actions",
                            align: "right",
                            width: "110px",
                            fixed: "right"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "static inline-block text-left container-action"
                                    },
                                    [
                                      _c(
                                        "VueCustomTooltip",
                                        {
                                          attrs: {
                                            label: "Detail",
                                            position: "is-left"
                                          }
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "p-2 w-8 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none",
                                              on: {
                                                click: function($event) {
                                                  return _vm.detail(scope.row)
                                                }
                                              }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                staticClass: "text-white",
                                                attrs: { icon: ["fa", "eye"] }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "ModalDialogDetail",
        {
          attrs: {
            isShowingModal: _vm.toggleDetail,
            title: "Transaction Details"
          },
          on: {
            toggleModal: function($event) {
              _vm.toggleDetail = !_vm.toggleDetail
            }
          }
        },
        [
          _c("template", { slot: "body" }, [
            _c("div", { staticClass: "py-4" }, [
              _c("div", { staticClass: "flex" }, [
                _c(
                  "div",
                  { staticClass: "w-1/2" },
                  [
                    _c("form-item", {
                      attrs: { label: "TRX ID" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "text-left font-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.detailTrans != null
                                      ? _vm.detailTrans.trx_id || "-"
                                      : "-"
                                  )
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("form-item", {
                      attrs: { label: "Email" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "text-left font-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.detailTrans != null
                                      ? _vm.detailTrans.email
                                      : "-"
                                  )
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("form-item", {
                      attrs: { label: "Status" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "text-left font-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.detailTrans != null
                                      ? _vm.detailTrans.status_text
                                      : "-"
                                  )
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("form-item", {
                      attrs: { label: "Channel" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "text-left font-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.detailTrans != null
                                      ? _vm.detailTrans.channel_name
                                      : "-"
                                  )
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("form-item", {
                      attrs: { label: "Type" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "text-left font-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.detailTrans != null
                                      ? _vm.detailTrans.type
                                      : "-"
                                  )
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("form-item", {
                      attrs: { label: "Currency" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "text-left font-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.detailTrans != null
                                      ? _vm.detailTrans.original_currency
                                      : "-"
                                  )
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "w-1/2" },
                  [
                    _c("form-item", {
                      attrs: { label: "Price" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "text-left font-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.detailTrans != null
                                      ? _vm.detailTrans.original_currency +
                                          " " +
                                          this.formatPrice(
                                            parseFloat(
                                              _vm.detailTrans.original_price
                                            ).toFixed(2)
                                          )
                                      : "-"
                                  )
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("form-item", {
                      attrs: { label: "Fee" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "text-left font-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.detailTrans != null
                                      ? _vm.detailTrans.original_currency +
                                          " " +
                                          this.formatPrice(
                                            parseFloat(
                                              _vm.detailTrans.fee
                                            ).toFixed(2)
                                          )
                                      : "-"
                                  )
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("form-item", {
                      attrs: { label: "Net" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "text-left font-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.detailTrans != null
                                      ? _vm.detailTrans.original_currency +
                                          " " +
                                          this.formatPrice(
                                            parseFloat(
                                              _vm.detailTrans.net_revenue
                                            ).toFixed(2)
                                          )
                                      : "-"
                                  )
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("form-item", {
                      attrs: { label: "Final Currency" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "text-left font-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.detailTrans != null
                                      ? _vm.detailTrans.final_currency
                                      : "-"
                                  )
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("form-item", {
                      attrs: { label: "Final Price" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "text-left font-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.detailTrans != null
                                      ? _vm.detailTrans.final_price_text
                                      : "-"
                                  )
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("form-item", {
                      attrs: { label: "Final Fee" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "text-left font-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.detailTrans != null
                                      ? _vm.detailTrans.fee_text
                                      : "-"
                                  )
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("form-item", {
                      attrs: { label: "Final Net" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "text-left font-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.detailTrans != null
                                      ? _vm.detailTrans.net_price_text
                                      : "-"
                                  )
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    })
                  ],
                  1
                )
              ])
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-251e0226", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-251e0226","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/SubscriptionHistory.vue
// module id = null
// module chunks = 